export const commonTranslationKeys = {
  commonHide: 'common.hide',
  commonAbout: 'common.about',
  commonAllLabel: 'common.all-label',

  commonAnd: 'common.and',
  commonCancel: 'common.cancel',
  commonChangesSaved: 'common.changes-saved',
  commonClose: 'common.close',
  commonConfirm: 'common.confirm',
  commonConfirmed: 'common.confirmed',
  commonCountryLabel: 'common.country-label',
  commonDay: 'common.day',
  commonDays: 'common.days',
  commonDelete: 'common.delete',
  commonDeleted: 'common.deleted',
  commonDone: 'common.done',
  commonEdit: 'common.edit',
  commonErrorDefaultDescription: 'common.error-default-description',

  commonErrorDefaultMessage: 'common.error-default-message',
  commonErrorWarningTitle: 'common.error-warning-title',
  commonGoBack: 'common.go-back',
  commonHour: 'common.hour',
  commonHours: 'common.hours',
  commonLeave: 'common.leave',
  commonMinute: 'common.minute',
  commonMinutes: 'common.minutes',
  commonNA: 'common.na',
  commonNew: 'common.new',
  commonNo: 'common.no',

  commonNoData: 'common.no-data',
  commonNotConfirmed: 'common.not-confirmed',

  commonOfTheDay: 'common.of-the-day',
  commonOfTheHour: 'common.of-the-hour',

  commonOfTheMinute: 'common.of-the-minute',

  commonOkayGotIt: 'common.okay-got-it',
  commonProceed: 'common.proceed',

  commonSave: 'common.save',
  commonSaveChanges: 'common.save-changes',

  commonSend: 'common.send',

  commonShowAll: 'common.show-all',
  commonSomethingWentWrong: 'common.something-went-wrong',
  commonSomethingWrongTryAgain: 'common.something-wrong-try-again',
  commonSuccess: 'common.success',
  commonTryAgain: 'common.try-again',
  commonYes: 'common.yes',
  statisticsFiltersApplyFilters: 'statistics.filters-apply-filters',
  statisticsFiltersClearAll: 'statistics.filters-clear-all',
  tableError: 'statistics.table-error',
}
